import { render, staticRenderFns } from "./SubscriptionList.vue?vue&type=template&id=d88d4864&"
import script from "./SubscriptionList.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports